import React from 'react'

import { PlusOutlined } from '@ant-design/icons'
import SupplierListView from '@components/shared/suppliers/SupplierListView'
import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import ListPageHeader from '@shared/ListPageHeader'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { supplierService } from '@services/operator/supplierService'

export default function OperatorSupplierList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchants } = useOperatorData()
  const isStandard = useIsStandard()

  return (
    <div>
      <ListPageHeader
        items={['purchase_orders', 'purchase_orders.suppliers']}
        actions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/suppliers/new')}
          >
            {t('common.button.new')}
          </Button>
        }
      />
      <SupplierListView
        service={supplierService}
        role="operator"
        showMerchantColumn={!isStandard}
        merchants={merchants}
      />
    </div>
  )
}
